import React, { useEffect, useState } from "react";
import AppShell from "../components/AppShell";
import { api } from "../lib/api";
import StatusBadge, { ocrStatusVariant } from "../components/StatusBadge";

export default function OcrQueue() {
  const [docs, setDocs] = useState([]);
  const [types, setTypes] = useState([]);

  const load = async () => {
    const [q, t] = await Promise.all([
      api.get("/documents/ocr-queue"),
      api.get("/document-types"),
    ]);
    setDocs(q.data);
    setTypes(t.data);
  };
  useEffect(() => { load(); }, []);

  const classify = async (id, code) => {
    const fd = new FormData();
    fd.append("document_type_code", code);
    await api.post(`/documents/${id}/classify`, fd);
    load();
  };

  const reprocess = async (id) => {
    await api.post(`/documents/${id}/reprocess-ocr`);
    setTimeout(load, 1500);
  };

  return (
    <AppShell title="OCR Queue">
      <div className="ds-card overflow-x-auto">
        <table className="ds-table" data-testid="ocr-queue-table">
          <thead>
            <tr>
              <th>Filename</th>
              <th>Status</th>
              <th>OCR text (preview)</th>
              <th>Classify as</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {docs.map((d) => (
              <tr key={d.id} data-testid={`queue-row-${d.id}`}>
                <td className="font-mono text-[12px] truncate max-w-[260px]">{d.filename}</td>
                <td><StatusBadge variant={ocrStatusVariant(d.ocr_status)}>{d.ocr_status}</StatusBadge></td>
                <td className="text-[11.5px] text-[#4A4A52] truncate max-w-[420px]">{(d.ocr_text || "").slice(0, 200)}</td>
                <td>
                  <select
                    defaultValue=""
                    onChange={(e) => e.target.value && classify(d.id, e.target.value)}
                    className="ds-input"
                    data-testid={`classify-select-${d.id}`}
                  >
                    <option value="" disabled>Choose type…</option>
                    {types.map((t) => <option key={t.code} value={t.code}>{t.name}</option>)}
                  </select>
                </td>
                <td className="text-right">
                  <button className="ds-btn-secondary" onClick={() => reprocess(d.id)} data-testid={`reprocess-${d.id}`}>
                    Reprocess
                  </button>
                </td>
              </tr>
            ))}
            {docs.length === 0 && (
              <tr><td colSpan={5} className="text-center text-[#8A8A93] py-8">Queue clear.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </AppShell>
  );
}
